/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DbrEventEntity } from '../../models/dbr-event-entity';

export interface EventsControllerFindAll$Params {
}

export function eventsControllerFindAll(http: HttpClient, rootUrl: string, params?: EventsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DbrEventEntity>>> {
  const rb = new RequestBuilder(rootUrl, eventsControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DbrEventEntity>>;
    })
  );
}

eventsControllerFindAll.PATH = '/events';
